import React from 'react';
import { useTranslation } from 'react-i18next';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import { useSelector } from 'react-redux';
import { Field, Form } from 'react-final-form';
import { RotatingLines } from 'react-loader-spinner';

import Title from '../components/title/Title';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import Icon from '../../../../icons/Icon';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import PlatformDropdowns from '../../../story/adjust/params-section/components/PlatformDropdowns';
import { MEDIA_TYPES, STORY_PLATFORM_TYPES } from '../../../../constants';

import scss from './FormSection.module.scss';
import { useProject } from '../../../../context/ProjectContext';

function FormSection() {
  const { t } = useTranslation('activ8');
  const { actions } = useProject();

  const initialAdjustMessage = useSelector((state) => state.activ8Messages.initialAdjustMessage);
  const isPlatformsLoading = useSelector((state) => state.story.isPlatformsLoading);

  const initialValues = {
    message: initialAdjustMessage ?? '',

    [STORY_PLATFORM_TYPES.LINKEDIN]: [],
    [STORY_PLATFORM_TYPES.YOUTUBE]: [],
    [STORY_PLATFORM_TYPES.META]: [],
    [STORY_PLATFORM_TYPES.BANNERS]: [],
    [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: [],
    [STORY_PLATFORM_TYPES.LONG_FORM]: [],
  };

  const handleSubmit = async (values) => {
    await actions('adjustMessages', { message: values.message, ...values });
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      render={({ handleSubmit, submitting }) => (
        <form className={scss.wrapper} onSubmit={handleSubmit}>
          <div className={scss.messageBlock}>
            <Title title={t('yourMessage')} subtitle={t('enterYourMessageThatYouWantToAdjust')} />
            <Field name='message'>
              {({ input, meta }) => (
                <CommonTextarea
                  rows={6}
                  onChange={input.onChange}
                  onBlur={input.onBlur}
                  onFocus={input.onFocus}
                  value={input.value}
                  isError={meta.touched && meta.error}
                  enableVoiceInput
                />
              )}
            </Field>
          </div>

          <div className={scss.settingsBlock}>
            <Title title={t('settings')} subtitle={t('choosePlatformsAndFormatsToAdjustYourMessageFor')} />

            {isPlatformsLoading ? (
              <div className={scss.loaderWrapper}>
                <RotatingLines
                  strokeColor='#fdbf47'
                  strokeWidth={5}
                  animationDuration='0.75'
                  width={24}
                  visible={true}
                />
              </div>
            ) : null}

            <PlatformDropdowns className={scss.dropdowns} mediaType={MEDIA_TYPES.IMAGE} />
          </div>

          <TooltipButton type='submit' styleColor={BUTTON_STYLES.PRIMARY} isLoading={submitting}>
            <Icon icon={BuildOutlinedIcon} />
            {t('adjust')}
          </TooltipButton>
        </form>
      )}
    />
  );
}

export default FormSection;
